// Shared HTML helpers for the side panels. Pure string helpers — no DOM.

import { firstLabel, secondLabel } from '../model/labels';

export function esc(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

// A remixicon sprite icon, as the view's pl2_icon helper renders it.
export function icon(id) {
  return `<svg aria-hidden="true"><use href="/icons/__remixicon.sprite.svg?v=491#${id}"/></svg>`;
}

export function cap(s) { return s ? s[0].toUpperCase() + s.slice(1) : s; }

// An element's name (v1 AbstractShape.name): its first label with a value, of
// any type; else its first plant's name; else its type. Images use their name.
export function elementLabel(el, species = {}) {
  if (el.type === 'image') return el.data?.name || 'Image';
  const first = firstLabel(el.data?.labels, species);
  if (first) return first;
  const sid = (el.speciesIds || [])[0];
  if (sid != null) return species[sid]?.name || `Plant #${sid}`;
  return cap(el.type);
}

// The muted second line next to the name (v1 secondaryName), or ''.
export function elementSecondaryLabel(el, species = {}) {
  if (el.type === 'image') return '';
  return secondLabel(el.data?.labels, species) || '';
}

export function rgbaToHex(rgba) {
  if (!rgba) return '#000000';
  const m = String(rgba).match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (!m) return '#000000';
  return '#' + [m[1], m[2], m[3]].map((n) => Number(n).toString(16).padStart(2, '0')).join('');
}

// Convert a color-input hex back to rgba, keeping the previous alpha.
export function hexToRgba(hex, prev) {
  const m = String(hex).match(/^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
  if (!m) return prev || null;
  const r = parseInt(m[1], 16); const g = parseInt(m[2], 16); const b = parseInt(m[3], 16);
  let alpha = 1;
  const pm = String(prev || '').match(/rgba?\([^)]*,\s*([\d.]+)\s*\)/);
  if (pm) alpha = parseFloat(pm[1]);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// Shown in the species flyout on plant rows that place on click.
export const PLACE_HINT = 'Click, then click the canvas to place';

// One plant row (search results, lists, add-plant modal): thumb + name + sci
// name, wrapped so callers can add data attributes and trailing actions.
export function plantRowInner(p) {
  return `${p.thumb ? `<img class="pl2-result__img" src="${esc(p.thumb)}" alt="">` : '<span class="pl2-result__img"></span>'}
    <span class="pl2-result__text"><span class="pl2-result__name">${esc(p.name || '')}</span><span class="pl2-result__sci">${esc(p.scientific_name || '')}</span></span>`;
}

// Small external-link icon button to a plant's profile page. Rendered as a real
// anchor — the click handler lets it through instead of treating it as a row action.
export function profileLink(link) {
  if (!link) return '';
  return `<a class="pl2-iconbtn pl2-profile-link" data-profile href="${esc(link)}" target="_blank" rel="noopener" data-tip="Open plant profile" aria-label="Open plant profile">↗</a>`;
}
